var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2004 6.4C11.4404 6.4 10.0004 4.96 10.0004 3.2C10.0004 1.44 11.4404 0 13.2004 0C14.9604 0 16.4004 1.44 16.4004 3.2C16.4004 4.96 14.9604 6.4 13.2004 6.4ZM21.2004 0H24.4004V0.64C24.2404 4.16 23.1204 6.88 20.7204 8.8C19.9204 9.44 18.9604 9.92 18.0004 10.24V32H14.8004V22.4H11.6004V32H8.40039V12.96C7.92039 13.12 7.60039 13.28 7.44039 13.44C6.00039 14.56 5.21639 16 5.20039 18.4V19.2H2.00039V18.4C2.00039 15.2 3.13639 12.656 5.37639 10.736C7.13639 9.296 10.0004 8 13.2004 8C16.4004 8 17.4884 7.264 18.7684 6.304C20.3684 5.024 21.2004 3.2 21.2004 0.8V0ZM0.400391 22.4H5.20039V32H0.400391V22.4Z",
    fill: "#F2F2F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/stop_icon.519a7bc07edcf1f9b6be95f71b449c8f.svg";
export { ForwardRef as ReactComponent };